<template>
	<gpsh-app></gpsh-app>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
	components: {
		'gpsh-app': () => import('./app.vue')
	},

	data() {
		return {};
	},

	created() {
		console.log('BeechUiRoot created', this);
	},
	mounted() {
		console.log('BeechUiRoot mounted', this);
	},
	updated() {
		console.log('BeechUiRoot updated', this);
	},
	destroyed() {
		console.log('BeechUiRoot destroyed', this);
	}
});
</script>
